import React from 'react';

import { Checkbox, FormControlLabel, styled } from '@mui/material';
import { Controller } from 'react-hook-form';

import { type ControlledCheckboxProps } from './types';
import { IconTooltip } from '../common/Tooltip/IconTooltip';

const StyledDiv = styled('div')`
    display: flex;
    align-items: center;
`;

export const ControlledCheckbox: React.FC<ControlledCheckboxProps> = (props) => (
    <Controller
        name={props.name}
        control={props.control}
        render={({ field }) => (
            <StyledDiv>
                <FormControlLabel
                    label={props.label}
                    control={
                        <Checkbox
                            {...field}
                            {...props}
                            ref={props.ref}
                            checked={field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                        />
                    }
                />
                {props.hint && <IconTooltip>{props.hint}</IconTooltip>}
            </StyledDiv>
        )}
    />
);

export default ControlledCheckbox;
